module.exports = "pegasus/assets/theme6/google-icon.png";